import React from 'react';
import { Heart, Instagram } from 'lucide-react';
import { mockData } from '../mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const quickLinks = [
    { label: 'Início', id: 'home' },
    { label: 'Sobre Nós', id: 'about' },
    { label: 'Programas', id: 'programs' },
    { label: 'Contato', id: 'contact' }
  ];

  return (
    <footer className="bg-gradient-to-b from-gray-800 to-gray-900 text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* About Section */}
          <div>
            <div className="mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_bb20f472-f37c-4f14-a7f8-13b7abd8c0d5/artifacts/2l1s8394_Logo02.png"
                alt="Logo Recanto Abelhinha"
                className="h-20 w-auto mb-4"
              />
            </div>
            <p className="text-gray-300 mb-4 leading-relaxed">
              {mockData.school.tagline}
            </p>
            <p className="text-amber-400 font-semibold">
              {mockData.school.yearsOfExperience} anos de tradição
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6">Links Rápidos</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-gray-300 hover:text-amber-400 transition-colors flex items-center gap-2 group"
                  >
                    <span className="w-0 h-0.5 bg-amber-400 group-hover:w-4 transition-all"></span>
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-6">Contato</h4>
            <ul className="space-y-3 text-gray-300">
              <li>
                <a href={`tel:${mockData.school.phone}`} className="hover:text-amber-400 transition-colors">
                  {mockData.school.phone}
                </a>
              </li>
              <li>
                <a href={`tel:${mockData.school.phone2}`} className="hover:text-amber-400 transition-colors">
                  {mockData.school.phone2}
                </a>
              </li>
              <li>
                <a href={`mailto:${mockData.school.email}`} className="hover:text-amber-400 transition-colors break-all">
                  {mockData.school.email}
                </a>
              </li>
              <li className="text-sm leading-relaxed">
                {mockData.school.address}
              </li>
            </ul>
          </div>

          {/* Social Media & Hours */}
          <div>
            <h4 className="text-lg font-bold mb-6">Redes Sociais</h4>
            <div className="flex gap-3 mb-6">
              <a
                href={mockData.school.socialMedia.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-700 hover:bg-gradient-to-br hover:from-purple-500 hover:to-pink-500 rounded-full flex items-center justify-center transition-all hover:scale-110"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
            </div>
            
            <div className="bg-gray-800 rounded-lg p-4 border border-gray-700">
              <p className="text-sm font-semibold mb-2">Horário</p>
              <p className="text-gray-400 text-sm">
                Seg - Sex: 7h às 18h30
              </p>
              <p className="text-amber-400 text-xs mt-2">
                Visitas com agendamento
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-gray-700">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
            <p>
              © {currentYear} Recanto de Educação Infantil Abelhinha. Todos os direitos reservados.
            </p>
            <p className="flex items-center gap-2">
              Feito com <Heart size={16} className="text-red-400 fill-red-400" /> para as crianças
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
